import logoLc from '@/assets/print/logo-lc.svg'

interface WrongNotePrintFooterProps {
  pageNumber: number
}

/**
 * 오답노트 인쇄물 매 페이지 하단 footer (Figma node 654:942).
 * 좌하단: LC 로고 / 우하단: 페이지번호.
 * 페이지 컨테이너(.print-page, position:relative) 기준 absolute로 깔린다.
 */
export function WrongNotePrintFooter({ pageNumber }: WrongNotePrintFooterProps) {
  return (
    <div
      data-testid="wrong-note-print-footer"
      className="absolute inset-x-0 bottom-0 flex items-center justify-between px-[72px] pb-[48px]"
    >
      <img data-testid="wrong-note-footer-logo" src={logoLc} width={90} height={25} alt="QUEBON Learning Center" />
      <span data-testid="wrong-note-footer-page-number" className="text-[16px] font-semibold tracking-[-0.096px] text-black">
        {pageNumber}
      </span>
    </div>
  )
}
